import {
  BatchCollectionMgmtBibliographyBulkRemovalConditionListItem,
  BatchCollectionMgmtBibliographyBulkRemovalConditionListItemFromJSON
} from '@/api/models/batch/BatchCollectionMgmtBibliographyBulkRemovalConditionListItem'

export interface BatchCollectionMgmtBibliographyBulkRemovalPageLoadResult {
  items: BatchCollectionMgmtBibliographyBulkRemovalConditionListItem
}

export function BatchCollectionMgmtBibliographyBulkRemovalPageLoadResultFromJSON(
  json: any
): BatchCollectionMgmtBibliographyBulkRemovalPageLoadResult {
  return {
    items: BatchCollectionMgmtBibliographyBulkRemovalConditionListItemFromJSON(
      json
    )
  }
}
